import React from 'react';
import { Icon } from '../../../primitives/Icon';
import { Path, G } from 'react-native-svg';

export function Stroked(props: any) {
  return (
    <Icon color={props.color} viewBox="0 0 69.672 69.672" size={props.size}>
      <G id="Group_252" data-name="Group 252" transform="translate(32.661)">
        <Path
          id="Path_17"
          data-name="Path 17"
          d="M242.194,8.958a2.175,2.175,0,0,1-2.175-2.175V2.175a2.175,2.175,0,1,1,4.349,0V6.783A2.175,2.175,0,0,1,242.194,8.958Z"
          transform="translate(-240.019 0)"
          fill={props.color}
        />
        <Path
          id="Path_18"
          data-name="Path 18"
          d="M242.194,455.127a2.175,2.175,0,0,1-2.175-2.175v-4.609a2.175,2.175,0,1,1,4.349,0v4.609A2.175,2.175,0,0,1,242.194,455.127Z"
          transform="translate(-240.019 -385.455)"
          fill={props.color}
        />
      </G>
      <G
        id="Group_253"
        data-name="Group 253"
        transform="translate(16.33 4.376)"
      >
        <Path
          id="Path_19"
          data-name="Path 19"
          d="M125.574,40.2a2.175,2.175,0,0,1-2.971-.8l-2.3-3.991a2.175,2.175,0,0,1,3.766-2.175l2.3,3.991a2.174,2.174,0,0,1-.8,2.971Z"
          transform="translate(-120.007 -32.155)"
          fill={props.color}
        />
        <Path
          id="Path_20"
          data-name="Path 20"
          d="M348.658,426.6a2.175,2.175,0,0,1-2.971-.8l-2.3-3.991a2.175,2.175,0,1,1,3.767-2.175l2.3,3.991A2.174,2.174,0,0,1,348.658,426.6Z"
          transform="translate(-312.735 -365.968)"
          fill={props.color}
        />
      </G>
      <G
        id="Group_254"
        data-name="Group 254"
        transform="translate(4.375 16.33)"
      >
        <Path
          id="Path_21"
          data-name="Path 21"
          d="M40.2,125.574a2.175,2.175,0,0,1-2.971.8l-3.991-2.3a2.175,2.175,0,0,1,2.175-3.767l3.991,2.3A2.175,2.175,0,0,1,40.2,125.574Z"
          transform="translate(-32.154 -120.007)"
          fill={props.color}
        />
        <Path
          id="Path_22"
          data-name="Path 22"
          d="M426.6,348.658a2.175,2.175,0,0,1-2.971.8l-3.991-2.3a2.175,2.175,0,1,1,2.175-3.766l3.991,2.3A2.174,2.174,0,0,1,426.6,348.658Z"
          transform="translate(-365.968 -312.735)"
          fill={props.color}
        />
      </G>
      <G id="Group_255" data-name="Group 255" transform="translate(0 32.661)">
        <Path
          id="Path_23"
          data-name="Path 23"
          d="M8.958,242.194a2.175,2.175,0,0,1-2.175,2.175H2.175a2.175,2.175,0,1,1,0-4.349H6.783A2.175,2.175,0,0,1,8.958,242.194Z"
          transform="translate(0 -240.019)"
          fill={props.color}
        />
        <Path
          id="Path_24"
          data-name="Path 24"
          d="M455.127,242.194a2.175,2.175,0,0,1-2.175,2.175h-4.609a2.175,2.175,0,1,1,0-4.349h4.609A2.175,2.175,0,0,1,455.127,242.194Z"
          transform="translate(-385.455 -240.019)"
          fill={props.color}
        />
      </G>
      <G
        id="Group_256"
        data-name="Group 256"
        transform="translate(4.376 16.33)"
      >
        <Path
          id="Path_25"
          data-name="Path 25"
          d="M40.2,344.179a2.175,2.175,0,0,1-.8,2.971l-3.991,2.3a2.175,2.175,0,0,1-2.175-3.766l3.991-2.3A2.175,2.175,0,0,1,40.2,344.179Z"
          transform="translate(-32.155 -312.735)"
          fill={props.color}
        />
        <Path
          id="Path_26"
          data-name="Path 26"
          d="M426.6,121.1a2.175,2.175,0,0,1-.8,2.971l-3.991,2.3a2.175,2.175,0,0,1-2.175-3.766l3.991-2.3A2.174,2.174,0,0,1,426.6,121.1Z"
          transform="translate(-365.97 -120.007)"
          fill={props.color}
        />
      </G>
      <G
        id="Group_257"
        data-name="Group 257"
        transform="translate(16.33 4.375)"
      >
        <Path
          id="Path_27"
          data-name="Path 27"
          d="M125.574,418.839a2.175,2.175,0,0,1,.8,2.971l-2.3,3.991a2.175,2.175,0,0,1-3.767-2.175l2.3-3.991A2.175,2.175,0,0,1,125.574,418.839Z"
          transform="translate(-120.007 -365.968)"
          fill={props.color}
        />
        <Path
          id="Path_28"
          data-name="Path 28"
          d="M348.658,32.445a2.175,2.175,0,0,1,.8,2.971l-2.3,3.991a2.175,2.175,0,1,1-3.766-2.175l2.3-3.991A2.174,2.174,0,0,1,348.658,32.445Z"
          transform="translate(-312.735 -32.154)"
          fill={props.color}
        />
      </G>
    </Icon>
  );
}
